// import React, { useState } from "react";
// // import { useNavigate } from "react-router-dom";

// const About = () => {
//   // const [isExpanded, setIsExpanded] = useState(false);
//   const [isExpanded2, setIsExpanded2] = useState(false);
//   // const navigate = useNavigate();

//   return (
//     <div className="text-gray-800 font-sans">
//       {/* Hero Section */}
//       <section className="relative h-[60vh] flex items-center justify-center text-white text-center px-4 overflow-hidden">
//         {/* Background image layer */}
//         <div
//           className="absolute inset-0 bg-cover bg-center"
//           style={{
//             backgroundImage: `url("https://res.cloudinary.com/dxdvcplbl/image/upload/v1754842640/DJI_20250810155011_0041_D-min_rpyzkh.jpg")`,
//           }}
//         ></div>

//         {/* Overlay */}
//         <div className="absolute inset-0 bg-black opacity-50"></div>

//         {/* Foreground content */}
//         <div className="relative z-10 max-w-4xl">
//           <h1 className="text-3xl md:text-5xl font-bold leading-snug">
//             "RGCC is a scenic 9-hole premier riverside golf destination where
//             Rangpur’s golfing legacy meets luxury and leisure."
//           </h1>
//         </div>
//       </section>

//       {/* Intro Section */}

//       <section className="py-16 px-4 md:px-20 bg-white grid md:grid-cols-2 gap-10">
//         <img
//           src="https://res.cloudinary.com/dxdvcplbl/image/upload/v1754842629/DJI_20250810155606_0047_D-min_vmsho6.jpg"
//           alt="Golf Course"
//           className="w-full h-auto rounded-lg"
//         />
//         <div>
//           <h2 className="text-xl font-bold mb-4">
//             Rangpur Golf & Country Club
//           </h2>
//           <div
//             className={`overflow-hidden transition-all duration-500 ease-in-out ${
//               isExpanded2 ? "max-h-[1000px]" : "max-h-[6em]"
//             }`}
//           >
//             <p className="">
//               Welcome to Rangpur Golf & Country Club (RGCC), a distinguished
//               golfing destination in northern Bangladesh. Since its inception in
//               the early 1990s by Major General AMSA Amin, our club has grown
//               into a vibrant hub for golf enthusiasts, fostering a spirit of
//               camaraderie and sporting excellence. The most pivotal chapter in
//               the history of RGCC was written under the extra-ordinary
//               leadership of the present president Major General Mohammad Kamrul
//               Hasan, GOC 66 Inf Div and Area Comd, Rangpur Area. His vision and
//               dedication have been the driving forces behind the remarkable
//               transformation of this beautiful golf course. Recognizing the
//               potential of the club, Major General Kamrul Hasan initiated a
//               comprehensive development plan and elevated RGCC to a newer height
//               within a very short span of time. Only his personal interest has
//               made it possible to build an iconic and aesthetic clubhouse,
//               adjusting the courses, enhancing the facilities, and introducing
//               modern amenities to ensure an unparallel experience for members.
//               The unwavering commitment of our present president Major General
//               Kamrul Hasan has not only enriched the club’s infrastructure but
//               also strengthened the sporting community, attracting more members
//               and hosting numerous prestigious tournaments. Under his able
//               guidance, RGCC has become a beacon of excellence and innovation in
//               northern Bangladesh’s golfing landscape, making it a proud symbol
//               of luxury, tradition, and progress. Thanks to the respected
//               President for his remarkable and exceptional leadership. His
//               impeccable contribution includes exquisitely maintained greens,
//               scenic views along the Ghaghat river, and top-tier facilities
//               including premium restaurant, luxurious lounge, resourceful pro
//               shop, time worthy and effective driving range, an global standard
//               carparking, landscaping in front of golf house and professional
//               coaching services. Since joining the Golf Federation in 2016, RGCC
//               has hosted over 70 tournaments, with a growing and passionate
//               membership of 245 dedicated golfers. Join us at RGCC to experience
//               the legacy of outstanding leadership and to be part of a thriving
//               community that is redefining golf in northern Bangladesh.
//             </p>
//           </div>
//           <div className="flex gap-4">
//             <button
//               onClick={() => setIsExpanded2(!isExpanded2)}
//               className="text-black mt-4 text-sm underline hover:text-black/70 transition-colors duration-300"
//             >
//               {isExpanded2 ? "READ LESS" : "READ MORE"}
//             </button>
//           </div>
//         </div>
//       </section>
//     </div>
//   );
// };

// export default About;

import React, { useEffect, useRef, useState } from "react";
import {
  ChevronDown,
  ChevronUp,
  Flag,
  Trophy,
  Users,
  MapPin,
} from "lucide-react";

const About = () => {
  const [isExpanded, setIsExpanded] = useState(false);

  const historyRef = useRef(null);

  useEffect(() => {
    setTimeout(() => {
      if (historyRef.current) {
        historyRef.current.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }
    }, 1000);
  });

  const features = [
    {
      icon: <Flag className="w-6 h-6" />,
      title: "9-Hole Championship Course",
      description: "Professional layout with scenic river views",
    },
    {
      icon: <Trophy className="w-6 h-6" />,
      title: "70+ Tournaments",
      description: "Hosted prestigious golf events since 2016",
    },
    {
      icon: <Users className="w-6 h-6" />,
      title: "245+ Members",
      description: "Growing community of passionate golfers",
    },
    {
      icon: <MapPin className="w-6 h-6" />,
      title: "Prime Riverside Location",
      description: "Breathtaking views along the Ghaghat river",
    },
  ];

  return (
    <div className="font-sans">
      {/* Hero Section */}
      <section className="relative min-h-[80vh] md:min-h-[90vh] flex items-center justify-center text-white overflow-hidden">
        {/* Background Image with Gradient Overlay */}
        <div className="absolute inset-0">
          <img
            src="https://res.cloudinary.com/dxdvcplbl/image/upload/v1754842640/DJI_20250810155011_0041_D-min_rpyzkh.jpg"
            alt="RGCC Golf Course"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-gray-900/80 via-gray-900/60 to-emerald-900/40"></div>
        </div>

        {/* Hero Content */}
        <div className="relative z-10 max-w-6xl px-4 md:px-8 text-center">
          <div className="inline-flex items-center gap-2 mb-6">
            <div className="w-12 h-12 rounded-full bg-gradient-to-br from-emerald-500/20 to-lime-500/20 backdrop-blur-sm border border-emerald-400/30 flex items-center justify-center">
              <Flag className="w-6 h-6 text-emerald-300" />
            </div>
          </div>

          <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold leading-tight mb-6">
            Where Rangpur's Golfing{" "}
            <span className="relative inline-block">
              <span className="relative z-10 bg-gradient-to-r from-emerald-300 to-lime-300 bg-clip-text text-transparent">
                Legacy
              </span>
              {/* <span className="absolute bottom-2 left-0 w-full h-3 bg-gradient-to-r from-emerald-500/30 to-lime-500/30 -rotate-1"></span> */}
            </span>{" "}
            Meets Luxury
          </h1>

          <p className="text-xl md:text-2xl text-gray-200 max-w-4xl mx-auto leading-relaxed">
            A premier riverside golf destination where tradition, excellence,
            and natural beauty converge
          </p>

          {/* Scroll Indicator */}
          <div className="mt-12 animate-bounce">
            <ChevronDown className="w-8 h-8 text-emerald-300 mx-auto" />
          </div>
        </div>
      </section>

      {/* Main Content */}
      <div className="bg-gradient-to-br from-gray-50 via-white to-emerald-50/30">
        {/* Intro Section */}
        <section className="py-16 md:py-24 px-4 md:px-8 max-w-7xl mx-auto">
          <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
            {/* Image Column */}
            <div className="relative group">
              <div className="absolute -inset-4 bg-gradient-to-r from-emerald-400 to-lime-400 rounded-2xl blur-xl opacity-20 group-hover:opacity-30 transition-opacity duration-500"></div>
              <div className="relative rounded-2xl overflow-hidden shadow-2xl">
                <img
                  src="https://res.cloudinary.com/dxdvcplbl/image/upload/v1754842629/DJI_20250810155606_0047_D-min_vmsho6.jpg"
                  alt="RGCC Golf Course"
                  className="w-full h-auto transform group-hover:scale-105 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-gray-900/20 to-transparent"></div>
              </div>
            </div>

            {/* Text Column */}
            <div ref={historyRef}>
              <div className="inline-flex items-center gap-2 mb-4">
                <span className="w-8 h-0.5 bg-gradient-to-r from-emerald-500 to-lime-500"></span>
                <span className="text-sm font-semibold tracking-widest text-emerald-600 uppercase">
                  Established 1990s
                </span>
                <span className="w-8 h-0.5 bg-gradient-to-r from-lime-500 to-emerald-500"></span>
              </div>

              <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
                Rangpur Golf & Country Club
              </h2>

              <div
                className={`prose prose-lg max-w-none ${
                  !isExpanded ? "line-clamp-6" : ""
                }`}
              >
                <p className="text-gray-600 leading-relaxed mb-4">
                  Welcome to Rangpur Golf & Country Club (RGCC), a distinguished
                  golfing destination in northern Bangladesh. Since its
                  inception in the early 1990s by Major General AMSA Amin, our
                  club has grown into a vibrant hub for golf enthusiasts,
                  fostering a spirit of camaraderie and sporting excellence.
                </p>
                <p className="text-gray-600 leading-relaxed mb-4">
                  The most pivotal chapter in the history of RGCC was written
                  under the extraordinary leadership of the present president
                  Major General Mohammad Kamrul Hasan, GOC 66 Inf Div and Area
                  Comd, Rangpur Area. His vision and dedication have been the
                  driving forces behind the remarkable transformation of this
                  beautiful golf course.
                </p>
                <p className="text-gray-600 leading-relaxed mb-4">
                  Recognizing the potential of the club, Major General Kamrul
                  Hasan initiated a comprehensive development plan and elevated
                  RGCC to a newer height within a very short span of time. Only
                  his personal interest has made it possible to build an iconic
                  and aesthetic clubhouse, adjusting the courses, enhancing the
                  facilities, and introducing modern amenities to ensure an
                  unparalleled experience for members.
                </p>
                <p className="text-gray-600 leading-relaxed mb-4">
                  The unwavering commitment of our present president Major
                  General Kamrul Hasan has not only enriched the club's
                  infrastructure but also strengthened the sporting community,
                  attracting more members and hosting numerous prestigious
                  tournaments.
                </p>
                <p className="text-gray-600 leading-relaxed">
                  Under his able guidance, RGCC has become a beacon of
                  excellence and innovation in northern Bangladesh's golfing
                  landscape, making it a proud symbol of luxury, tradition, and
                  progress.
                </p>
              </div>

              <button
                onClick={() => setIsExpanded(!isExpanded)}
                className="inline-flex items-center gap-2 mt-6 px-6 py-3 rounded-full font-semibold text-emerald-600 hover:text-emerald-700 bg-emerald-50 hover:bg-emerald-100 transition-all duration-300 group"
              >
                {isExpanded ? (
                  <>
                    Show Less
                    <ChevronUp className="w-4 h-4 group-hover:-translate-y-0.5 transition-transform" />
                  </>
                ) : (
                  <>
                    Read Full Story
                    <ChevronDown className="w-4 h-4 group-hover:translate-y-0.5 transition-transform" />
                  </>
                )}
              </button>
            </div>
          </div>

          {/* Features Grid */}
          <div className="mt-20 md:mt-24 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {features.map((feature, index) => (
              <div
                key={index}
                className="bg-white/80 backdrop-blur-sm rounded-2xl p-6 border border-gray-100 shadow-sm hover:shadow-xl hover:border-emerald-100 transition-all duration-300 group"
              >
                <div className="w-14 h-14 rounded-xl bg-gradient-to-br from-emerald-50 to-lime-50 flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300">
                  <div className="text-emerald-600">{feature.icon}</div>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">
                  {feature.title}
                </h3>
                <p className="text-gray-600 text-sm">{feature.description}</p>
              </div>
            ))}
          </div>

          {/* Legacy Section */}
          <div className="mt-20 bg-gradient-to-r from-emerald-50 to-lime-50 rounded-2xl p-8 md:p-12 border border-emerald-100">
            <div className="text-center max-w-3xl mx-auto">
              <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-gradient-to-br from-white to-emerald-50 border border-emerald-100 mb-6">
                <Trophy className="w-8 h-8 text-emerald-600" />
              </div>
              <h3 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4">
                A Legacy of Excellence
              </h3>
              <p className="text-gray-600 text-lg">
                Since joining the Golf Federation in 2016, RGCC has hosted over
                70 tournaments, with a growing and passionate membership of 245
                dedicated golfers. Join us at RGCC to experience the legacy of
                outstanding leadership and to be part of a thriving community
                that is redefining golf in northern Bangladesh.
              </p>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default About;
